import * as React from "react";
import styled, { keyframes } from "styled-components";
import theme from "../theme";

const float = keyframes`
  0%, 100% {
		transform: translateY(4px);
	}
	50% {
		transform: translateY(-4px);
	}
`;

const List = styled.ul`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 1px;
  width: 50px;
  list-style-type: none;
  margin: auto;
`;

const Item = styled.li`
  width: 4px;
  height: 28px;
  background: ${theme.color.red};
  animation: ${float} 1.8s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;
  &:nth-child(1) {
    height: 18px;
    margin-top: 7px;
    animation-delay: 0.1s;
  }
  &:nth-child(2) {
    height: 22px;
    margin-top: 5px;
    animation-delay: 0.2s;
  }
  &:nth-child(3) {
    animation-delay: 0.3s;
  }
  &:nth-child(4) {
    animation-delay: 0.4s;
  }
  &:nth-child(5) {
    height: 22px;
    margin-top: 5px;
    animation-delay: 0.5s;
  }
  &:nth-child(6) {
    height: 18px;
    margin-top: 7px;
    animation-delay: 0.6s;
  }
`;

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  height: 100vh;
`;

class LoadingIcon extends React.Component {
  render() {
    return (
      <Container>
        <List>
          <Item />
          <Item />
          <Item />
          <Item />
          <Item />
          <Item />
        </List>
      </Container>
    );
  }
}

export default LoadingIcon;



// WEBPACK FOOTER //
// ./src/modules/LoadingIcon.tsx